export class GetTwenty47RequestFormRequest {
   Twenty47RequestId : string;
}